module.exports = __webpack_public_path__ + "img/6.528490cd.jpg";